var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('smooth-scrollbar',[_c('div',{staticClass:"vector-group",staticStyle:{"margin":"0 1.4rem","height":"56vh"}},_vm._l((_vm.vectors_group),function(_vectors,index){return _c('vector-group',{key:index,attrs:{"group":_vectors}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }